/* eslint-disable */
export const playIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.757 9.05334C21.8111 10.1704 21.8111 13.062 19.757 14.1791L7.35414 20.9237C5.35772 22.0094 2.9043 20.5963 2.9043 18.3608V4.8716C2.9043 2.63612 5.35772 1.22307 7.35413 2.30872L19.757 9.05334Z" stroke="currentColor" stroke-width="1.4521"/></svg>`,
  name: 'play' as const,
};
